import React from 'react';

const Youtube = props => (
  <svg width={24} height={17} {...props}>
    <path
      d="M16.538 8.532l-6.769 4.331A.5.5 0 0 1 9 12.441V3.779a.498.498 0 0 1 .769-.421l6.769 4.331a.5.5 0 0 1 0 .843M20.062 0H3.937A3.944 3.944 0 0 0 0 3.94v9.121A3.943 3.943 0 0 0 3.937 17h16.125A3.943 3.943 0 0 0 24 13.061V3.94A3.944 3.944 0 0 0 20.062 0"
      fill="#647A85"
      fillRule="evenodd"
      opacity={0.3}
    />
  </svg>
);

export default Youtube;
